import React from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {getAiPoweredReviewsPanelVisibility} from 'modules/overlay/selectors'

import {Button} from '@vio/atlas/src/components/designSystem/Button'
import {Icon} from '@vio/atlas/src/components/designSystem/Icon'
import {OverlayPage} from '@vio/atlas/src/components/designSystem/OverlayPage'
import {BodyWrapper, PopUp} from '@vio/atlas/src/components/designSystem/PopUp'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {aiReviewsMessages} from '../constants'
import {useAiPoweredInsight} from '../useAiPoweredInsight'
import {AiPoweredReviewsPanelContent} from './AiPoweredReviewsPanelContent'

const POPUP_WIDTH = 764

const StyledPopUp = styled(PopUp)`
  z-index: 105;

  ${BodyWrapper} {
    padding: 0;
    overflow: hidden;
  }
`

interface Props {
  hotelId: string
  initialCategory?: string
  onClose: () => void
  onShowAllReviews: () => void
}
export const AiPoweredReviewsPanel: React.FC<Props> = ({
  hotelId,
  initialCategory,
  onClose,
  onShowAllReviews
}) => {
  const {isMobile} = useDeviceLayout()

  const isPanelOpen = useSelector(getAiPoweredReviewsPanelVisibility)

  const {isLoading, isEnabled} = useAiPoweredInsight(hotelId)

  if (!isEnabled || isLoading) return null

  if (isMobile) {
    return (
      <OverlayPage
        prerenderContent
        isOpen={isPanelOpen}
        onClose={onClose}
        hasHeaderBoxShadow={false}
        navBarProps={{
          centerContent: (
            <FormattedMessageWrapper
              {...aiReviewsMessages.aiPoweredReviewGuestInsights}
            />
          ),
          endContent: (
            <Button
              size="lg"
              hasTouchArea
              onClick={onClose}
              variant="ghostInverse"
            >
              <Text
                variant="titleM"
                colorPath="content.neutral.primary"
                tag="span"
              >
                <Icon name="Close" size="lg" />
              </Text>
            </Button>
          )
        }}
      >
        <AiPoweredReviewsPanelContent
          hotelId={hotelId}
          initialCategory={initialCategory}
          onShowAllReviews={onShowAllReviews}
        />
      </OverlayPage>
    )
  }

  return (
    <StyledPopUp
      prerenderContent
      className="--ai-powered-reviews-panel"
      isOpen={isPanelOpen}
      closeAction={onClose}
      width={POPUP_WIDTH}
      navBarProps={{
        centerContent: (
          <FormattedMessageWrapper
            {...aiReviewsMessages.aiPoweredReviewGuestInsights}
          />
        ),
        endContent: (
          <Button
            size="lg"
            hasTouchArea
            onClick={onClose}
            variant="ghostInverse"
          >
            <Text
              variant="titleM"
              colorPath="content.neutral.primary"
              tag="span"
            >
              <Icon name="Close" size="lg" />
            </Text>
          </Button>
        )
      }}
    >
      <AiPoweredReviewsPanelContent
        hotelId={hotelId}
        initialCategory={initialCategory}
        onShowAllReviews={onShowAllReviews}
      />
    </StyledPopUp>
  )
}
